import moment from 'moment';
import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store';
import i18n from '@/i18n';
import H_auditRecord from '@/helpers/auditRecord';

export default {
  async getFactoryIndex(factoryId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'audit_record',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async show(recordId, params) {
    //取得record內容
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      modelName: 'audit_record',
      modelId: recordId,
      params: _params,
    });
    return res;
  },
  async create(auditId, data) {
    //create record
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'audit',
      parentId: auditId,
      modelName: 'audit_record',
      data: _data,
    });
    return res;
  },
  async answerIndex(recordId, params) {
    //取得record內容
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'audit_record',
      parentId: recordId,
      modelName: 'audit_record_answer',
      params: _params,
    });
    return res;
  },
  getTimeFormat(date) {
    if (!date) return '';
    return moment(date)
      .format('YYYY-MM-DD HH:mm:ss');
  },
  getDateFormat(date) {
    if (!date) return '';
    return moment(date)
      .format('YYYY-MM-DD');
  },
  getChaptersWithAnswers(chapters, answers) {
    if (!chapters || !answers || chapters.length === 0 || answers.length === 0)
      return [];
    let _chapters = chapters.map((chapter) => {
      return {
        badId: chapter.badId,
        title: chapter.title,
        sectionList: chapter.sections.map((section) => {
          const _questionList = [];
          section.questions.forEach((question) => {
            const answer = answers.find(
              (answer) => answer.questionId === question.id,
            );
            if (answer) {
              let alertText = '';
              const riskSignal = answer.riskSignal;
              if (riskSignal) {
                if (riskSignal[0] && riskSignal[0].length) {
                  alertText += riskSignal[0].map(e => e.name).join('、');
                }
                if (riskSignal[1] && riskSignal[1].length) {
                  if (alertText) alertText += '、';
                  alertText += riskSignal[1].map(e => e.name).join('、');
                }
              }
              question.alertText = answer.score !== 25 && alertText
                ? `${i18n.t('風險')}：${i18n.t(alertText)}`
                : '';
              const _question = { ...question, ...answer };
              _questionList.push(_question);
            }
          });
          return {
            badId: section.badId,
            title: section.title,
            questionList: _questionList,
          };
        }),
      };
    });
    return _chapters;
  },
  getCustomedIndex(list) {
    let _list = JSON.parse(JSON.stringify(list));
    _list.forEach((chapter) => {
      const cIndex = _list.indexOf(chapter) + 1;
      chapter.chapterCustomedIndex = `${cIndex}` + '.';
      chapter.sectionList.forEach((section) => {
        const sIndex = chapter.sectionList.indexOf(section) + 1;
        section.sectionCustomedIndex = `${cIndex}` + '-' + `${sIndex}` + '.';
        section.questionList.forEach((question) => {
          const qIndex = section.questionList.indexOf(question) + 1;
          question.questionCustomedIndex =
            `${cIndex}` + '-' + `${sIndex}` + '-' + `${qIndex}` + '.';
        });
      });
    });
    return _list;
  },
  async createReviewDraft(factoryId, data) {
    //create record
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'audit_review_draft',
      data: _data,
    });
    return res;
  },
  async showReviewDraft(recordId, params) {
    //取得review draft內容
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      modelName: 'audit_record',
      modelId: recordId,
      params: _params,
    });
    return res;
  },
  async updateRecord(recordId, data) {
    //create record
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'audit_record',
      modelId: recordId,
      data: _data,
    });
    return res;
  },
  async index(auditId, params) {
    //record index in audit
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'audit',
      parentId: auditId,
      modelName: 'audit_record',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async updateReviewRemark(recordId, data) {
    //create record
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      parentName: 'audit_record',
      parentId: recordId,
      modelName: 'review_remark',
      data: _data,
    });
    return res;
  },
  async getChapterList(apiData) {
    let res = apiData;
    const recordId = apiData.id;
    const recordContent = H_auditRecord.getRecordData(res);
    res = await this.answerIndex(recordId);
    const recordAnswers = H_auditRecord.getRecordAnswers(res);
    const list = this.getChaptersWithAnswers(
      recordContent.chapters,
      recordAnswers,
    );
    const listWithIndex = this.getCustomedIndex(list);
    return listWithIndex;
  },
};
